import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'

export const IconLinkItemSchema = buildEntrySchemaFor('iconLinkItem', {
  fields: z.lazy(() =>
    z.object({
      title: z.string(),
      eyebrow: safeOptional(z.string()),
      heading: RichTextSchema,
      description: RichTextSchema,
      href: z.string(),
      label: z.string(),
      alt: safeOptional(z.string()),
      icon: z.string(),
    }),
  ),
})
export type IconLinkItem = z.infer<typeof IconLinkItemSchema>
